import React from 'react';

const FRUSTRATIONAL_MAX_ACCURACY = 90;
const INSTRUCTIONAL_MAX_ACCURACY = 95;

export const HEADER_TITLES = [
    {
        firstPart: 'Book Level',
        secondPart: '& Title',
        className: 'book-level-title',
        cellClassName: 'cell-level-title',
    },
    {
        firstPart: 'Book',
        secondPart: 'Performance',
        className: 'book-performance',
        cellClassName: 'cell-performance',
    },
    { secondPart: 'Genre', className: 'book-genre', cellClassName: 'cell-genre' },
    {
        firstPart: 'Reading',
        secondPart: 'Accuracy',
        className: 'book-reading-accuracy',
        cellClassName: 'cell-reading-accuracy',
    },
    {
        firstPart: 'Reading',
        secondPart: 'Comp',
        className: 'book-reading-comp',
        cellClassName: 'cell-reading-comp',
    },
    {
        firstPart: 'Written',
        secondPart: 'Comp',
        className: 'book-written-comp',
        cellClassName: 'cell-written-comp',
    },
    {
        firstPart: 'Assessment',
        secondPart: 'Mode',
        className: 'book-assessment-mode',
        cellClassName: 'cell-assessment-mode',
    },
];

export const getAccuracy = accuracy => {
    let accuracySignClassName = 'icon-independent';
    if (accuracy < FRUSTRATIONAL_MAX_ACCURACY) {
        accuracySignClassName = 'icon-frustrational';
    } else if (accuracy < INSTRUCTIONAL_MAX_ACCURACY) {
        accuracySignClassName = 'icon-instructional';
    }
    return (
        <>
            {accuracy}% <i className={accuracySignClassName} />
        </>
    );
};
